import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

import { useSite } from "@/contexts/SiteContext";

export default function WhatsAppFloat() {
  const [hover, setHover] = useState(false);
  const { site } = useSite();
  const number = (site.whatsappNumber || "").replace(/\D/g, "");
  const message = encodeURIComponent(
    "Hello PIRAC, I would like to enquire about your property advisory services."
  );

  // No number configured means no floating button, rather than a link to nowhere.
  if (!number) return null;

  return (
    <a
      href={`https://wa.me/${number}?text=${message}`}
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-float fixed z-40 bottom-6 right-6 lg:bottom-8 lg:right-8"
      data-testid="whatsapp-float"
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      aria-label="Chat with PIRAC on WhatsApp"
    >
      <span className="relative flex h-14 w-14 items-center justify-center bg-[#cca24d] text-[#060f1e] shadow-[0_10px_40px_-10px_rgba(204,162,77,0.55)] animate-pulse-soft rounded-full">
        <svg viewBox="0 0 24 24" className="h-6 w-6" fill="currentColor" aria-hidden="true">
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.031-.966-.273-.099-.471-.148-.67.15-.198.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.298-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.095 3.2 5.076 4.487.709.306 1.262.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347zM12.04 21.785h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.002-5.45 4.436-9.884 9.889-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.992c-.003 5.45-4.437 9.886-9.885 9.886zm8.413-18.298A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.304-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.82 11.82 0 00-3.489-8.414z" />
        </svg>
      </span>
      <AnimatePresence>
        {hover && (
          <motion.span
            initial={{ opacity: 0, x: 10 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: 10 }}
            className="hidden lg:block absolute right-16 top-1/2 -translate-y-1/2 whitespace-nowrap bg-[#060f1e] text-[#f7f5f0] text-xs px-3 py-2 border border-[#1a2940]"
          >
            Speak with a PIRAC Advisor
          </motion.span>
        )}
      </AnimatePresence>
    </a>
  );
}
